import client from './api-client'

export const serviceGetInformeAnalytic = async () => {
  try {
    const response = await client.get(`analytic2`)
    if (response.status === 200 && response.data.code === 1) {
      return response.data
    } else {
      throw new Error(response.data.message)
    }
  } catch (error) {
    throw error
  }
}

export const enviarInformeAnalytic = async(data) => {
    
    try {
        
        const response = await client.post('analytic2',data);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message)
        }

    } catch(error){
        throw error;
    }
}

